import {
  Component, Input, OnInit, AfterViewInit, EventEmitter, Output,
  SimpleChanges, OnChanges
} from '@angular/core';
import {MatDialog} from '@angular/material';
import { ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder  } from '@angular/forms';
import { OrdersService } from '../../../services/orders.service';
import {DialogSharedComponent} from '../../dialog-shared/dialog-shared.component';

declare var $: any;

@Component({
    selector: 'orders-section',
    templateUrl: './orders-section.component.html',
    styleUrls: ['./orders-section.component.scss']
})
export class OrdersSectionComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() orders = [];
    @Input() disableSearch = false;

    @Output() getOrd = new EventEmitter();

    shipments: any;
    progress = false;
    ordersForm: FormGroup;
    dataAll: any;

    logged = false;
    isOrder = false;
    paginatePages = [1, 2, 3, 4, 5];
    searchSelect = [
        { value: 1, label: 'Order ID' },
        { value: 2, label: 'Shipment ID' },
        { value: 3, label: 'Customer number' },
        { value: 4, label: 'Adyen payment reference' },
        { value: 5, label: 'Unifaun order reference' },
        { value: 6, label: 'Pickup address info (address, name, email)' },
        { value: 7, label: 'Delivery address (address, name, email)' },
        { value: 8, label: 'Billing address (address, name, email)' },
    ];
    statuses = [
        { value: 1, label: 'authorized', icon: 'how_to_reg' },
        { value: 2, label: 'approved', icon: 'check_circle_outline' },
        { value: 3, label: 'delivered', icon: 'local_shipping' },
        { value: 4, label: 'cancelled', icon: 'cancel' },
        { value: 5, label: 'partly_approved', icon: 'check' },
        { value: 6, label: 'approving', icon: 'check' },
        { value: 7, label: 'ready_to_capture', icon: 'layers' },
        { value: 8, label: 'captured', icon: 'local_grocery_store' },
        { value: 9, label: 'new', icon: 'fiber_new' },
        { value: 10, label: 'aquthorization_failed', icon: 'person_add_disabled' },
        { value: 11, label: 'shipment_storing_failed', icon: 'remove_shopping_cart' },
        { value: 12, label: 'capture_failed', icon: 'add' },
    ];
    page = 1;
    pages = 1;
    pageSize = 50;
    shipmentsEnable = Array.from(new Array(50), (val, index) => false);
    @ViewChild('modal1') public tempRef: ElementRef;
    constructor(private _fb: FormBuilder, private orderService: OrdersService, public dialog: MatDialog) {}

    ngOnInit() {
      this.ordersForm = this._fb.group({
          search: [''],
      });
      this.getOrders();

    }

    ngOnChanges(changes: SimpleChanges) {
      if (changes.orders.currentValue && changes.orders.currentValue.data) {
        this.pages = Math.ceil(Number(changes.orders.currentValue.total) / this.pageSize);
        this.dataAll = changes.orders.currentValue;
        this.orders = [];
        for (const key in this.dataAll.data) {
          this.orders.push({
            orderRef: this.dataAll.data[key].order_number,
            amount: this.dataAll.data[key].amount,
            extra_charge: this.dataAll.data[key].extra_charge,
            extra_charge_failed: this.dataAll.data[key].extra_charge_failed,
            created: this.dataAll.data[key].created_at,
            billingAddress: this.dataAll.data[key].billing_address,
            canceled_at: this.dataAll.data[key].canceled_at == null ? false : true,
            order_id: this.dataAll.data[key].id,
            icon: this.find(this.dataAll.data[key].status).icon,
            status: this.find(this.dataAll.data[key].status).label,
            shipments: this.dataAll.data[key].shipments,
            consignee: ( this.dataAll.data[key].shipments.length > 0 ?
              (this.dataAll.data[key].shipments[0].consignee == null ?
                'null' : this.dataAll.data[key].shipments[0].consignee.address ) : 'null' ),
            consignor: ( this.dataAll.data[key].shipments.length > 0 ?
              (this.dataAll.data[key].shipments[0].consignor == null ?
                'null' : this.dataAll.data[key].shipments[0].consignor.address ) : 'null' )
          });
        }
        this.paginateSet();
        const openedOrder = this.shipmentsEnable.indexOf(true);
        if (openedOrder > -1) {
          this.shipments = this.dataAll.data[openedOrder].shipments;
        }
        if (this.pages > 0) {
          this.logged = true;
          this.isOrder = true;
        }
        if (this.pages === 0) {
          this.logged = true;
          this.isOrder = false;
        }
        this.progress = false;
      }
    }
    ngAfterViewInit() {
    }

    find(status) {
      for (let i = 0; i < this.statuses.length; i++) {
        if (this.statuses[i].value === status) {return this.statuses[i]; }
      }
    }

    getOrders() {
      this.getOrd.emit({
        page: this.page,
        pageSize: this.pageSize,
        value: this.ordersForm.controls['search'].value
      });
    }

    changePage(page) {
        if (page !== 'left' && page !== 'right') {
           this.page = page;
        }
        if (page === 'left' && this.page > 0) {
            this.page = this.page - 1;
        }
        if (page === 'right' && this.page < this.pages) {
            this.page = this.page + 1;
        }
        this.getOrders();

        return false;
    }

    paginateSet() {
        let page_i = 1;
        if (this.page >= 5) {
            page_i = this.page - 2;
        }
        this.paginatePages = [];

        for (let i = page_i; i <= this.pages; i++) {
            if (this.paginatePages.length === 5) {
                break;
            } else {
                this.paginatePages.push(i);
            }
        }

        return false;
    }

    startSearch() {
        this.orderService.getOrders(1, this.pageSize, this.ordersForm.controls['search'].value).subscribe((resp) => {
            if (typeof resp.data !== 'undefined') {
                for (const i in this.shipmentsEnable) {
                    this.shipmentsEnable[i] = false;
                }
                this.pages = Math.ceil(Number(resp.total) / this.pageSize);
                this.dataAll = resp;
                this.orders = [];
                this.page = 1;
                this.paginateSet();
                for (const key in resp.data) {
                    this.orders.push({
                        orderRef: resp.data[key].order_number,
                        amount: resp.data[key].amount,
                        extra_charge: resp.data[key].extra_charge,
                        extra_charge_failed: resp.data[key].extra_charge_failed,
                        created: resp.data[key].created_at,
                        billingAddress: resp.data[key].billing_address,
                        canceled_at: resp.data[key].canceled_at == null ? false : true,
                        order_id: resp.data[key].id,
                        consignee: resp.data[key].shipments[0].consignee.address,
                        consignor: resp.data[key].shipments[0].consignor.address
                    });
                }
            } else {
              const dialogRef = this.dialog.open(DialogSharedComponent,
                {width: '450px', data: { errorType: 'null', header: 'order.notFound' }});
            }
        });

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/atoms/orders-section/orders-section.component.ts